import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import Image from 'next/image';

import { ImageFragmentFragment } from '../../__generated__/graphql';

import style from './svg.module.css';

interface SvgProps {
  containerClassName?: string;
  image: ImageFragmentFragment | null | undefined;
  maxWidth?: null | number;
  priority?: boolean;
}

const Svg = ({
  containerClassName,
  image,
  maxWidth,
  priority,
}: SvgProps) => (
  <div
    className={classNames(style.svgContainer, containerClassName)}
    {...maxWidth ? { style: { maxWidth } } : {}}
  >
    <Image
      alt={image?.node.altText ?? ''}
      fetchPriority="high"
      fill
      priority={priority}
      src={image?.node.link ?? ''}
      style={{
        // "fill" automatically adds a bunch of styles
        // we want to render the SVG as is
        bottom: undefined,
        color: undefined,
        height: undefined,
        inset: undefined,
        left: undefined,
        position: undefined,
        right: undefined,
        top: undefined,
        width: undefined,
      }}
      unoptimized
    />
  </div>
);

export default Svg;
